import { render, staticRenderFns } from "./RequisitionDeleteModal.vue?vue&type=template&id=37ef7409&scoped=true&"
import script from "./RequisitionDeleteModal.vue?vue&type=script&lang=js&"
export * from "./RequisitionDeleteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ef7409",
  null
  
)

export default component.exports